import {
  getTeamMappingList,
  getcategoryTemplate,
  getCreateTemplate,
  editTeamMappingTemplate,
  deleteTeamMappingList,
  createTeamMappingList,
  updateTeamMapping,
} from "@/http/setup/teamMapping.js";

export default {
  namespaced: true,
  state: {
    teamMappings: [],
    categoryTemplate: [],
    createTemplate: [],
    editMappingTemplate: {},
  },
  actions: {
    async fetchTeamMappingList({ commit }) {
      try {
        const res = await getTeamMappingList();
        commit("SET_TEAM_MAPPING_LIST", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchEditTeamMappingTemplate({ commit }, id) {
      try {
        let res = await editTeamMappingTemplate(id);
        commit("EDIT_ITEM_MAPPING_TEMPLATE", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchCategoryTemplate({ commit }, id) {
      try {
        let res = await getcategoryTemplate(id);
        commit("SET_PRIORITY_MAPPING_TEMPLATE", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchCreateTemplate({ commit }) {
      try {
        let res = await getCreateTemplate();
        commit("SET_ITEM_MAPPING_TEMPLATES", res.data.createTemplate);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteTeamMappingAction({ commit }, id) {
      try {
        let res = await deleteTeamMappingList(id);
        commit("RESET_TEAM_MAPPING_LIST", id);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createTeamMappingList(_, payload) {
      try {
        let res = await createTeamMappingList(payload);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateTeamMapping(_, payload) {
      try {
        let res = await updateTeamMapping(payload.id, payload.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_PRIORITY_MAPPING_TEMPLATE(state, payload) {
      state.categoryTemplate = payload;
    },
    EDIT_ITEM_MAPPING_TEMPLATE(state, payload) {
      state.editMappingTemplate = payload;
    },
    SET_ITEM_MAPPING_TEMPLATES(state, payload) {
      state.createTemplate = payload;
    },
    SET_TEAM_MAPPING_LIST(state, payload) {
      state.teamMappings = payload;
    },
    RESET_TEAM_MAPPING_LIST(state, id) {
      state.teamMappings = state.teamMappings.filter((el) => el.id !== id);
    },
  },
};
